import * as styles from "./CardTurnstile.css";
import { ComponentPropsWithRef, ElementType, useEffect, useRef } from "react";
import DrawnCircle from "~/assets/svgs/DrawnCircle";
import { Check, X } from "@untitled-ui/icons-react";
import { fluid } from "~/styles/functions";
import { CardText } from "./CardText";
import Icon from "../elements/Icon";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

type CardTurnstileProps = {
  selected?: boolean;
  theme?: "primary" | "positive" | "negative";
  icon?: ElementType;
} & ComponentPropsWithRef<"div">;

export const CardTurnstile = ({
  children,
  selected = false,
  theme = "primary",
  icon,
  ...props
}: CardTurnstileProps) => {

  return (
    <div className={styles.theme({ theme: theme })}>
      <div className={styles.card} {...props}>
        <div className={styles.radioButton}>
          <DrawnCircle className={styles.circle} />

          <div className={styles.icon} id="icon">
            {icon && <Icon svg={icon} size="12px" />}
          </div>
        </div>
        <CardText theme="light" width="full" padding="small">
          {children}
        </CardText>
      </div>
    </div>
  );
};
